import { BellStatus, ConfigStatus, LoginConstants, RingPatterns, ScheduledRing, ScheduledRings } from './../constants/constants';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RingPattern } from '../constants/constants';
import { Utils } from '../constants/utils';
import scheduledRings from './scheduled-rings.json';
import ringPatterns from './ring-patterns.json';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  ringPatterns: BehaviorSubject<RingPatterns> = new BehaviorSubject(null);
  scheduledRings: BehaviorSubject<ScheduledRing[]> = new BehaviorSubject(null);
  bellStatus: BehaviorSubject<BellStatus> = new BehaviorSubject(null);
  configStatus: BehaviorSubject<ConfigStatus> = new BehaviorSubject(null);
  notificationBar: BehaviorSubject<{msgType:string, msg: string}> = new BehaviorSubject(null);
  isLoading: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {
    this.initWithDummyData();
  }

  initWithDummyData(){
    // this.ringPatterns.next(ringPatterns as RingPatterns);
    // this.scheduledRings.next(Utils.dictToList<ScheduledRing>(scheduledRings as ScheduledRings));
  }

  getAccessToken(): string {
    return localStorage.getItem(LoginConstants.ACCESS_TOKEN);
  }

  getRefreshToken(): string {
    return localStorage.getItem(LoginConstants.REFRESH_TOKEN);
  }
}
